export default "__VITE_ASSET__CLHw4Htu__"